import { useCallback, useContext, useState } from "react";
import Components from "../Components";
import { UIContext, UIProfile } from "../../contexts/UIContext";

function ButtonSpacer({ node }) {
  const [open, setOpen] = useState(false);
  const { uiProfile, setUIProfile, uiProfileJSON, setUIProfileJSON } =
    useContext(UIContext);

  const save = useCallback(() => {
    setUIProfileJSON(uiProfile.toJSON());
  }, [uiProfile]);

  return (
    <>
      <div
        className="m-2 rounded-sm text-center cursor-pointer items-center flex p-1 w-[90%] min-h-[35px] justify-center border-dashed border-red-400 border"
        onClick={() => {
          setOpen(true);
        }}
      >
        + Add component
      </div>

      <Components
        open={open}
        setOpen={setOpen}
        onSave={({ selectedItem }) => {
          node.addChild({ data: selectedItem });
          save();
          setOpen(false);
        }}
      />
    </>
  );
}

export default ButtonSpacer;
